import { render, staticRenderFns } from "./AdminEditProduct.vue?vue&type=template&id=23230ea6&scoped=true&"
import script from "./AdminEditProduct.vue?vue&type=script&lang=js&"
export * from "./AdminEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditProduct.vue?vue&type=style&index=0&id=23230ea6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23230ea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23230ea6')) {
      api.createRecord('23230ea6', component.options)
    } else {
      api.reload('23230ea6', component.options)
    }
    module.hot.accept("./AdminEditProduct.vue?vue&type=template&id=23230ea6&scoped=true&", function () {
      api.rerender('23230ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminEditProduct.vue"
export default component.exports